import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PractitionerByOrganizationAdapter } from 'app/core/adapters/practitioner-by-organization.adapter';
import { PractitionerAdapter } from 'app/core/adapters/practitioner.adapter';
import { PractitionerAPIResponse, Practitioner, practitionerI, BlockDaysInterface } from 'app/core/interfaces/practitioner';
import { environment } from 'app/environments/environment';
import { env } from 'process';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class PractitionerService {

  constructor(private http: HttpClient, private practitionerAdapter: PractitionerAdapter, private practitionerByOrganization: PractitionerByOrganizationAdapter) { }


  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public searchByToken(id: string) {
    return this.http.get<Practitioner>(
      `${environment.apiUrl}/secretarias-practitioner/token_id/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public findPractitionerroleByPractitionerId(id: string) {
    return this.http.get<Practitioner>(
      `${environment.apiUrl}/secretarias-practitioner/practitionerrole_id/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public create(params: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-practitioner`, params)
  }

  public createNew(practitioner: Practitioner): Observable<Practitioner> {

    const practitionerFHIR = this.practitionerAdapter.adaptToAPIFormat(practitioner)
    practitionerFHIR.token_id = localStorage.getItem('token_id') ?? ''

    return this.http.post<PractitionerAPIResponse>(`${environment.apiUrl}/secretarias-practitioner`, practitionerFHIR,  { headers: this.getHeaders() })
      .pipe(
        map((practitionerFHIR: PractitionerAPIResponse) => this.practitionerAdapter.adapterToModel(practitionerFHIR))
      );
  }

  public createByOrganization(practitioner: Practitioner, organization_id: string): Observable<Practitioner>{

    const practitionerFHIR = this.practitionerByOrganization.adaptToAPIFormat(practitioner)
   
    return this.http.post<PractitionerAPIResponse>(`${environment.apiUrl}/secretarias-practitioner/by-organization/${organization_id}`, practitionerFHIR,  { headers: this.getHeaders() })
      .pipe(
        map((practitionerFHIR: PractitionerAPIResponse) => this.practitionerByOrganization.adapterToModel(practitionerFHIR))
      );

  }

  public updateNew(practitioner_id: string, practitioner: Practitioner): Observable<Practitioner> {

    const practitionerFHIR = this.practitionerAdapter.adaptToAPIFormat(practitioner)


    return this.http.put<PractitionerAPIResponse>(`${environment.apiUrl}/secretarias-practitioner/${practitioner_id}`, practitionerFHIR)
      .pipe(
        map((practitionerFHIR: PractitionerAPIResponse) => this.practitionerAdapter.adapterToModel(practitionerFHIR))
      );

  }

  public updateByOrganization(practitioner_id: string,  organization_id: string, practitioner: Practitioner): Observable<Practitioner> {

    const practitionerFHIR = this.practitionerByOrganization.adaptToAPIFormat(practitioner)


    return this.http.put<PractitionerAPIResponse>(`${environment.apiUrl}/secretarias-practitioner/${practitioner_id}/by-organization/${organization_id}`, practitionerFHIR)
      .pipe(
        map((practitionerFHIR: PractitionerAPIResponse) => this.practitionerByOrganization.adapterToModel(practitionerFHIR))
      );

  }

  public update(id: string, params: practitionerI) {
    return this.http.put(`${environment.apiUrl}/secretarias-practitioner/${id}`, params)
  }

  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-practitioner/${id}`)
  }

  public show(id: string) {
    return this.http.get<Practitioner>(`${environment.apiUrl}/secretarias-practitioner/${id}`)
  }

  public showNew(id: string) {

    return this.http.get<PractitionerAPIResponse>(`${environment.apiUrl}/secretarias-practitioner/${id}`)
      .pipe(
        map((practitionersFHIR: PractitionerAPIResponse) => this.practitionerAdapter.adapterToModel(practitionersFHIR))
      );

  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-practitioner`)
  }

  public listNew() {
    return this.http.get<PractitionerAPIResponse[]>(`${environment.apiUrl}/secretarias-practitioner`)
      .pipe(
        map((practitionersFHIR: PractitionerAPIResponse[]) => practitionersFHIR.map(
          (practitionerFHIR: PractitionerAPIResponse) => this.practitionerAdapter.adapterToModel(practitionerFHIR))
        ));
  }

  public blockDays(practitioner_id: string, blockDays: any){

    return this.http.post<BlockDaysInterface[]>(`${environment.apiUrl}/secretarias-practitioner/${practitioner_id}/block-days`, blockDays)

  }

  public listBlockDays(practitioner_id: string){

    return this.http.get<BlockDaysInterface[]>(`${environment.apiUrl}/secretarias-practitioner/${practitioner_id}/block-days`)

  }

   public deleteBlockDays(practitioner_id: string, block_day_id: string) : Observable<BlockDaysInterface[]>{

    return this.http.delete<BlockDaysInterface[]>(`${environment.apiUrl}/secretarias-practitioner/${practitioner_id}/block-days/${block_day_id}`)

  }

 

  
}